module.exports = __webpack_public_path__ + "img/YB.3839bdc4.png";